<template>
  <div>
    <h1>register</h1>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped>
</style>
